import React from 'react'

export const UpgradeToPremium = React.lazy(
  () => import(/* webpackChunkName: "upgrade-to-premium-modal" */ '../modals/upgrade-to-premium'),
)
